import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const CustomerSupport = ({ children }) => {
  const Navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/admin/customer-support") {
      Navigate("/admin/customer-support/customer-tables");
    }
  }, [location, Navigate]);

  return (
    <div className="mt-4 ">
      <section>
        <div className="container">
          <div className="row">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CustomerSupport;
